import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import Amount from '../../components/amount'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { useOrderPurchaseMessage } from '../../hooks/use-order-puchase-message'
import { AdminButtonCounterCheckout } from '../../pages/admin/AdminButtonCounterCheckout'

const baseStyle = stylex.create({
  container: {
    padding: '32px 16px',
    borderRadius: '8px',
    gap: 12,
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    width: '100%',
  },
})

export const PaymentTip = () => {
  const { t } = useTranslation()
  const { destructuredData: orders } = useAdminOrders()
  const paymentMethodInfo = orders ? PaymentMethodMap[orders?.payment_method?.type] : ''
  const orderPurchaseMessage = useOrderPurchaseMessage(orders?.status)
  const isCompletedOrder = orders?.status === FastpassOrderStatus.COMPLETED

  if (!orders) return <Skeleton height={330} />
  return (
    <Box>
      <VStack rootStyle={baseStyle.container}>
        <Text color={isCompletedOrder ? colors.green400 : 'red'} variant="h2">
          {orderPurchaseMessage}
        </Text>
        <Text variant="h1">{paymentMethodInfo}</Text>
        {orders
          ? (
            <Box>
              <Amount
                bold
                fontSize={48}
                amount={orders?.total}
              />
            </Box>
          )
          : <Skeleton height="48px" variant="rounded" />}
        <AdminButtonCounterCheckout />
        <VStack alignItems="center">
          <Text variant="h5" color="red">{t('payment.warning')}</Text>
          <Text variant="h5" color="red">未點擊確認，將無法出貨給客人</Text>
        </VStack>
      </VStack>
    </Box>
  )
}
